import { createFileRoute, redirect } from '@tanstack/react-router'

import { requireManage } from '@/auth/require-manage'

export const Route = createFileRoute('/_layout/plo-solution-upload/gamemodes/$id/upload')({
  beforeLoad: ({ context, params }) => {
    requireManage(
      context.me,
      'plo-solution-upload',
      redirect({
        to: '/plo-solution-upload/gamemodes/$id',
        params: { id: params.id },
        replace: true,
      }),
    )
  },
})
